// extracted by mini-css-extract-plugin
module.exports = {"popover":"PopoverOnSvg_popover__3bN4H","arrow":"PopoverOnSvg_arrow__22-aj","content":"PopoverOnSvg_content__1rAgR","header":"PopoverOnSvg_header__URzxW"};